import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pager } from 'src/app/core';
import { GenericPaginationConfiguration } from './generic-pagination.interface';

@Component({
  selector: 'app-generic-pagination',
  templateUrl: './generic-pagination.component.html',
  styleUrls: ['./generic-pagination.component.less'],
})
export class GenericPaginationComponent implements OnInit {
  @Input() configuration: GenericPaginationConfiguration;

  @Output()
  genericPaginationIndexChange: EventEmitter<Pager> = new EventEmitter();

  @Output()
  genericPaginationPageSizeChange: EventEmitter<Pager> = new EventEmitter();

  private pageNumber: number = 1;
  ngOnInit(): void {}

  onNzPageIndexChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    let pager: Pager = { ...this.configuration.pager };
    pager.page = this.pageNumber;
    this.genericPaginationIndexChange.emit(pager);
  }

  onNzpageSizeChanged(perPage: number) {
    let pager: Pager = { ...this.configuration.pager };
    pager.perPage = perPage;
    pager.page = this.pageNumber;
    this.genericPaginationPageSizeChange.emit(pager);
  }
}
